// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export interface VulnerabilityPackagesQueryOptions {
  limit?: number;
  offset?: number;
  sortOrder?: 'asc' | 'desc';
  orderBy: 'packages' | 'Packages' | 'licenses';
}
